import { Stepper, Step, StepLabel } from '@mui/material'
import React from 'react'

interface IFormStepper {
  activeStep: number
  steps: string[]
}

const FormStepper: React.FC<IFormStepper> = ({ activeStep, steps }) => {
  return (
    <Stepper activeStep={activeStep} sx={{ margin: '2rem 0rem !important' }}>
      {steps.map((label, index) => {
        const stepProps: { completed?: boolean } = {}

        return (
          <Step
            key={label}
            {...stepProps}
            sx={{
              '& .MuiSvgIcon-root.Mui-completed': {
                color: 'green !important',
              },
            }}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        )
      })}
    </Stepper>
  )
}

export default FormStepper
